"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var WorkbookTemplateDescriptionSmall = /** @class */ (function (_super) {
    __extends(WorkbookTemplateDescriptionSmall, _super);
    function WorkbookTemplateDescriptionSmall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorkbookTemplateDescriptionSmall.prototype.render = function () {
        var _this = this;
        var handleClick = function (event) {
            event.preventDefault();
            _this.props.handleClick();
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, Localize_1.Messages.DatasourceHeaderMessage()),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ConnectionTypeSmallDescription }, this.props.starter.connectionType.displayName),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, this.props.starter.name),
            React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDescriptionText }, this.props.starter.description),
            React.createElement("div", null,
                React.createElement(widgets_1.TextLinkWidget, { testId: 'more-like-this', href: 'javascript:void(0)', onClick: handleClick }, Localize_1.Messages.MoreLikeThis()))));
    };
    return WorkbookTemplateDescriptionSmall;
}(React.Component));
exports.WorkbookTemplateDescriptionSmall = WorkbookTemplateDescriptionSmall;
//# sourceMappingURL=TemplateDescriptionSmall.js.map